import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UtilsService } from './utils.service';

@Injectable()
export class VirtualCardsService {
  constructor(
    private http: HttpService,
    private utils: UtilsService,
  ) {}

  getCards(
    page: number = 1,
    page_size: number = 50,
    q: string | null = null,
    user_id: number | string | null = null,
  ) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', page_size.toString());

    if (q) {
      params = params.set('q', q);
    }

    if (user_id !== null && user_id !== undefined && user_id !== '') {
      params = params.set('user_id', user_id.toString());
    }

    return new Promise((resolve, reject) => {
      this.http.get('virtual-cards', params).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  chargeMaintenance(body: {
    wallet_id?: string;
    user_subwallet_id?: number | string;
    user_id?: number | string;
    virtual_card_id?: number | string;
    billing_period?: string;
  } = {}) {
    const payload = this.utils.removeEmpty(body);

    return new Promise((resolve, reject) => {
      this.http.post('virtual-cards/charge-maintenance', payload).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getCreateFee(user_id: number | string | null = null) {
    let params = new HttpParams();

    if (user_id !== null && user_id !== undefined && user_id !== '') {
      params = params.set('user_id', user_id.toString());
    }

    return new Promise((resolve, reject) => {
      this.http.get('virtual-cards/create-fee', params).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  postCard(body: any) {
    body = this.utils.removeEmpty(body);

    return new Promise((resolve, reject) => {
      this.http.post('virtual-cards', body).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  changeCardStatus(card_id: any, status: any) {
    let body = {
      freeze: status === 'ACTIVE' ? true : false,
    };

    return new Promise((resolve, reject) => {
      this.http.post(`virtual-cards/${card_id}/freeze`, body).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getCardPAN(card_id: any) {
    return new Promise((resolve, reject) => {
      this.http.get(`virtual-cards/${card_id}/pan`).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getCardBalance(card_id: any) {
    return new Promise((resolve, reject) => {
      this.http.get(`virtual-cards/${card_id}/balance`).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getCardWallets(card_id: any) {
    return new Promise((resolve, reject) => {
      this.http.get(`virtual-cards/${card_id}/topup-wallets`).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getRechargeFee(card_id: number | string, amount: number | string) {
    const params = new HttpParams().set('amount', String(amount));

    return new Promise((resolve, reject) => {
      this.http.get(`virtual-cards/${card_id}/recharge-fee`, params).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  rechargeCard(
    card_id: number | string,
    body: {
      amount: number | string;
      wallet_id?: string;
      user_subwallet_id?: number | string;
    },
  ) {
    const payload = this.utils.removeEmpty(body);

    return new Promise((resolve, reject) => {
      this.http.post(`virtual-cards/${card_id}/recharge`, payload).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getCardTransactions(
    card_id: number | string,
    page: number = 1,
    page_size: number = 20,
    filters: {
      from_date?: string | null;
      to_date?: string | null;
      operations?: string[] | null;
    } = {},
  ) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', page_size.toString());

    if (filters.from_date) {
      params = params.set('from_date', filters.from_date);
    }
    if (filters.to_date) {
      params = params.set('to_date', filters.to_date);
    }
    (filters.operations || []).forEach((operation) => {
      if (operation) {
        params = params.append('operations', operation);
      }
    });

    return new Promise((resolve, reject) => {
      this.http
        .get(`virtual-cards/${card_id}/transactions`, params)
        .subscribe(
          (resp: any) => {
            resolve(resp);
          },
          (error) => {
            reject(error);
          },
        );
    });
  }
}
